import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';
import { mediaSelector } from 'helpers/style-utils';
import { Container } from 'client/components/pricing/styles';

const StyledPricingBlock = styled.div<{}>`
  padding: 60px 0;
`;

const Inner = styled(Container)`
  transition: padding 0.1s;

  ${mediaSelector.mobile} {
    padding: 0 20px;
  }
`;

export default function PricingBlock({
  className,
  children,
}: PropsWithChildren<{ className?: string }>) {
  return (
    <StyledPricingBlock className={className}>
      <Inner>{children}</Inner>
    </StyledPricingBlock>
  );
}
